import React, { Component } from 'react'
import { Route, Switch } from 'react-router' // react-router v4/v5
import indexRoutes from './routes/index'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'

import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'

import { motorService } from './services/motor.service'
import _ from 'lodash'

class App extends Component {
  getBrandCar = async () => {
    const {
      carBrandLoading,
      carBrandDone,
      carModelDone,
      carModelLoading,
    } = this.props
    try {
      carBrandLoading()
      carModelLoading()
      const responseV = await motorService.getBrandCarV()
      const responseC = await motorService.getBrandCarC()
      const dataV = _.get(responseV, 'data.string', [])
      const dataC = _.get(responseC, 'data.string', [])
      const responseModelV = await motorService.getModelCarV()
      const responseModelC = await motorService.getModelCarC()
      const dataModelV = _.get(responseModelV, 'data', [])
      const dataModelC = _.get(responseModelC, 'data', [])
      const { updateCarBrands, updateCarModels } = this.props
      updateCarBrands(dataV, dataC)
      updateCarModels(dataModelV, dataModelC)
      carBrandDone()
      carModelDone()
    } catch (error) {
      const { showError } = this.props
      showError(error.message)
      carBrandDone()
      carModelDone()
      if (error.message === 'Network Error') {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': error.message,
            'Error code': 'E10001',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: error.message,
          })
        }
        const {
          history: { push },
        } = this.props
        push('/error-network')
        document.getElementById('rootScreen').scrollTo(0, 0)
        return
      }
      const response = _.get(error, 'response', {})
      const responseStatus = response.status
      if (
        responseStatus === 500 ||
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response,
              'message',
              'Home - Get car data error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
            'Error code': 'E10002',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response,
              'message',
              'Home - Get car data error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
          })
        }
        const {
          history: { push },
        } = this.props
        push('/error-system')
        document.getElementById('rootScreen').scrollTo(0, 0)
        return
      }
    }
  }

  getCMI = async token => {
    const { CMILoading, CMIDone } = this.props
    try {
      CMILoading()
      const response = await motorService.getPackagesCMI(token)
      const { updateCMI } = this.props
      updateCMI(response)
      CMIDone()
    } catch (error) {
      CMIDone()
      const { showError } = this.props
      showError(error.message)
      // if (error.message === 'Network Error') {
      //   const {
      //     history: { push },
      //   } = this.props
      //   push('/error-network')
      //   window.scrollTo(0, 0)
      //   return
      // }
      // const response = _.get(error, 'response', {})
      // const responseStatus = response.status
      // if (
      //   responseStatus === 500 ||
      //   responseStatus === 403 ||
      //   responseStatus === 401 ||
      //   responseStatus === 400
      // ) {
      //   const mixpanel = _.get(window, 'mixpanel', undefined)
      //   if (!!mixpanel) {
      //     mixpanel.track('Insurance Car Error', {
      //       'Error message': _.get(
      //         response,
      //         'message',
      //         'Home - Get CMI packages error - ' +
      //           responseStatus +
      //           ' ' +
      //           _.get(error, 'message', '')
      //       ),
      //       'Error code': 'E10003',
      //     })
      //   }
      //   const dataLayer = _.get(window, 'dataLayer', undefined)
      //   if (!!dataLayer) {
      //     dataLayer.push({
      //       event: 'error-page', // Required
      //       errorMsg: _.get(
      //         response,
      //         'message',
      //         'Home - Get CMI packages error - ' +
      //           responseStatus +
      //           ' ' +
      //           _.get(error, 'message', '')
      //       ),
      //     })
      //   }
      //   const {
      //     history: { push },
      //   } = this.props
      //   push('/error-system')
      //   window.scrollTo(0, 0)
      //   document.getElementById("rootScreen").scrollTo(0, 0)
      //   return
      // }
    } //
  }

  componentDidMount = async () => {
    this.getBrandCar()
  }

  componentWillReceiveProps = nextProps => {
    if (
      _.get(nextProps, 'auth.token', '') !==
        _.get(this.props, 'auth.token', '') &&
      !!_.get(nextProps, 'auth.token', '')
    ) {
      this.getCMI(_.get(nextProps, 'auth.token', ''))
    }
  }

  render = () => {
    const { props } = this
    const { auth, closeError } = props
    const { isShowError, errorMessage } = auth
    return (
      <div
        id="rootScreen"
        style={{
          position: 'fixed',
          zIndex: 1,
          right: '0px',
          bottom: '0px',
          top: '0px',
          left: '0px',
          overflow: 'auto',
        }}
      >
        <ConnectedRouter history={props.history}>
          <Switch>
            {indexRoutes.map((prop, key) => (
              <Route
                path={prop.path}
                component={prop.component}
                key={key}
                exact={prop.exact}
              />
            ))}
          </Switch>
          {isShowError && false && (
            <section
              style={{
                position: 'fixed',
                bottom: '0',
                left: '0',
                background: 'rgba(255,0,0,0.8)',
                width: '100%',
                padding: '11px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ color: 'white' }}>{errorMessage}</span>
              <div onClick={closeError}>
                <IconButton
                  style={{
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    paddingRight: '0px',
                    paddingLeft: '6px',
                  }}
                >
                  <Icon
                    style={{
                      color: 'white',
                      fontSize: '19px',
                      fontWeight: 'bold',
                    }}
                  >
                    close
                  </Icon>
                </IconButton>
              </div>
            </section>
          )}
        </ConnectedRouter>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {},
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    CMILoading: () => {
      dispatch({
        type: 'API_PACKAGE_CMI_LOADING',
      })
    },
    CMIDone: () => {
      dispatch({
        type: 'API_PACKAGE_CMI_DONE',
      })
    },
    updateCMI: data => {
      dispatch({
        type: 'PACKAGES_CMI',
        data,
      })
    },
    carBrandLoading: () => {
      dispatch({
        type: 'API_CAR_BRAND_LOADING',
      })
    },
    carBrandDone: () => {
      dispatch({
        type: 'API_CAR_BRAND_DONE',
      })
    },
    updateCarBrands: (dataV, dataC) => {
      dispatch({
        type: 'CAR_BRANDS',
        dataV,
        dataC,
      })
    },
    carModelLoading: () => {
      dispatch({
        type: 'API_CAR_MODEL_LOADING',
      })
    },
    carModelDone: () => {
      dispatch({
        type: 'API_CAR_MODEL_DONE',
      })
    },
    updateCarModels: (dataV, dataC) => {
      dispatch({
        type: 'CAR_MODELS',
        dataV,
        dataC,
      })
    },
    closeError: () => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: false,
          errorMessage: '',
        },
      })
    },
    showError: message => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: true,
          errorMessage: message,
        },
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
